<template>
  <svg
    :width="`${size}`"
    :height="`${size}`"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 5C2 3.90625 2.875 3 4 3H16C17.0938 3 18 3.90625 18 5V15C18 16.125 17.0938 17 16 17H4C2.875 17 2 16.125 2 15V5ZM12.0938 8.34375C11.9688 8.125 11.7188 8 11.5 8C11.25 8 11 8.125 10.875 8.34375L8.15625 12.3438L7.3125 11.2812C7.1875 11.125 6.96875 11 6.75 11C6.5 11 6.28125 11.125 6.15625 11.2812L4.15625 13.7812C3.96875 14.0312 3.9375 14.3438 4.0625 14.5938C4.1875 14.8438 4.4375 15 4.75 15H7.75H8.75H15.25C15.5 15 15.7812 14.875 15.9062 14.625C16.0312 14.375 16 14.0625 15.8438 13.8438L12.0938 8.34375ZM5.5 8C6.3125 8 7 7.34375 7 6.5C7 5.6875 6.3125 5 5.5 5C4.65625 5 4 5.6875 4 6.5C4 7.34375 4.65625 8 5.5 8Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup lang="ts">
  defineProps({
    size: {
      type: Number,
      default: 20,
    },
  });
</script>
